import type { DocumentStateSeverity } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Shared/Helpers/resolveDocumentStateSeverity';

/** Tint of the state chip of an element; the text shown is the server's own `label`. */
const SEVERITY_BY_ELEMENT_STATE: Readonly<Record<string, DocumentStateSeverity>> = Object.freeze({
	uploading: 'info',
	transcribing: 'info',
	converting: 'info',
	conversion_failed: 'danger',
	transcription_failed: 'danger',
	not_transcribed: 'warning',
	ready: 'success',
});

/** An unrecognized value falls back to the neutral tint rather than throwing. */
const resolveElementStateSeverity = (stateValue: string): DocumentStateSeverity =>
	SEVERITY_BY_ELEMENT_STATE[stateValue] ?? 'secondary';

export default resolveElementStateSeverity;
